export {};
//# sourceMappingURL=definitions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@capacitor-community/apple-sign-in/dist/esm/definitions.js
// module id = 669
// module chunks = 112